// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: require('../../package.json').version,
  production: false,
  //urlAmbiente: 'http://habiente.getnet-uy.desa.cl',
  //urlAmbiente: 'https://par.getnetuy.testazure.com',
  //urlAmbiente: 'https://uat.par.getnetuy.evertecinc.com',
  urlAmbiente: 'https://debauto.getnet.com.uy',

  codCliente: 'BSANTANDUY',
  docEmpresa: '211307180016',
  //urlPortal: 'habiente.getnet-uy.desa.cl',
  //urlPortal: 'par.getnetuy.testazure.com',
  //urlPortal: 'uat.par.getnetuy.evertecinc.com',
  urlPortal: 'debauto.getnet.com.uy',

  tipoPortal: 'HABIENTE',
  binIsoPais: 'UY'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
